import * as Yup from 'yup'

// validation for Shipping screen fields
export const validationSchema = Yup.object({
  selectedShippingRateId: Yup.string().required(),
})
